const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hi',
    'Ref: Page content body':
      'On arrival and departure please be sure to remember to scan your QR Code Bus',
  },
};
export default labels;
